/* @flow */

import queryString from 'query-string';

import { API_URL } from '../../Constants';

type Coordinates = [number, number];

export type getPromoCodeOptions = {
  promoCode: string,
  origin: Coordinates,
  destination: Coordinates,
};

const stringifyCoordinates = arr => arr.join(',');

export function fetchCredits() {
  return {
    url: `${API_URL}/credits?credits_v2=true`,
    transform: (response: Object) => ({ credits: response }),
    update: {
      credits: (prevCredits: Object, credits: Object) => credits,
    },
  };
}

export function getPromoCode(options: getPromoCodeOptions) {
  let query = {
    origin: stringifyCoordinates(options.origin),
    destination: stringifyCoordinates(options.destination),
  };
  return {
    url: `${API_URL}/credits/${options.promoCode}?${queryString.stringify(query)}`,
    options: {
      method: 'GET',
    },
    transform: (response: Object) => ({ promoCode: response }),
    update: {
      promoCode: (prevPromoCode: Object, promoCode: Object) => promoCode,
    },
  };
}



// WEBPACK FOOTER //
// ./src/redux/current-user/queries.js